// extracted by mini-css-extract-plugin
export var euProgram = "eu-program-3-module--eu-program--PA+zn";